import React, { ReactNode } from 'react';


import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox, Grid, Typography } from 'web-library';

const useStyles = makeStyles()((theme) =>
({
  root: {},
  checkContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  checkSideWord: {
    flex: 1,
    '& .MuiTypography-root': {
      paddingBottom: theme.spacing(1),
    },
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  checkbox: {
    padding: 5,
    [theme.breakpoints.down('md')]: {
      paddingTop: 3,
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 2,
    },
  },
  subsection: {
    marginBottom: theme.spacing(3),
  },
  customDeclare: {
    marginTop: theme.spacing(3),
  },
}));

export interface DeclarationProps {
  customContent?: ReactNode;
  customDeclare?: ReactNode;
  title?: string;
  noTitle?: boolean;
  content?: string;
  isAgreed: boolean;
  isContentJustify?: boolean;
  className?: string;
  handleAgreement: () => void;
  accountType?: 'candidate' | 'coordinator';
}

const Declaration: React.FC<DeclarationProps> = (props: DeclarationProps) => {
  const {
    title = 'Declaration',
    noTitle,
    content,
    isAgreed = false,
    isContentJustify = false,
    handleAgreement = () => {
      // do nothing
    },
    accountType = 'candidate',
    customContent,
    customDeclare,
    className,
  } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();

  const onAgreed = () => {
    handleAgreement();
  };

  let defaultContent = t(
    'components->>Declaration.' +
    'I confirm that I am currently not studying in any government/government-aided/ Independent/ Specialised school. ' +
    'I have read the examination regulations/instructions and fulfil the requirements to register as a private candidate ' +
    'for GCE N(T)-, N(A)-, O- & A-Level examinations; and'
  );
  let defaultDeclare = t(
    'components->>Declaration.I declare ' +
    'that all information submitted by me in this form is true and correct to the best of my knowledge. ' +
    'I am fully aware that any false information given by me may render this application and the results invalid, ' +
    'the forfeiture of any payment made and/or subject me to prosecution.'
  );

  if (accountType === 'coordinator') {
    defaultContent = t('components->>Declaration.CoordinatorContent');
    defaultDeclare = t('components->>Declaration.CoordinatorDeclare');
  }

  return (
    (<Grid container className={`${classes.root} ${className}`} justify="flex-start">
      {!noTitle && (
        <Typography variant="h3" className={classes.subsection}>
          {title}
        </Typography>
      )}
      <Grid container md={12} direction="row">
        <Grid xs={12} className={classes.checkContainer}>
          <Checkbox
            id="checkbox-declaration"
            className={classes.checkbox}
            onChange={(e) => {
              onAgreed();
            }}
            checked={isAgreed}
            ariaLabel="agreement-declaration"
          />
          <Box className={classes.checkSideWord}>
            {customContent ? (
              <>
                <Typography align={isContentJustify ? 'justify' : 'inherit'} variant="body1">
                  {customContent}
                </Typography>
                {customDeclare && (
                  <Typography
                    align={isContentJustify ? 'justify' : 'inherit'}
                    className={classes.customDeclare}
                    variant="body1"
                  >
                    {customDeclare}
                  </Typography>
                )}
              </>
            ) : (
              <>
                {content ||
                  (defaultContent && (
                    <Typography variant="body1">{content || defaultContent}</Typography>
                  ))}
                <Typography variant="body1">{defaultDeclare}</Typography>
              </>
            )}
          </Box>
        </Grid>
      </Grid>
    </Grid>)
  );
};
export default Declaration;
